import React, { useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { TooltipMenu } from '../../../common/tooltip-menu';

const PollIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
    <path d='M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
    <path d='M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
  </svg>
);

const ActivityIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z' />
    <path d='M16 3v4' />
    <path d='M8 3v4' />
    <path d='M4 11h16' />
  </svg>
);

const RosterIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2' />
    <path d='M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z' />
    <path d='M9 12l2 2l4 -4' />
  </svg>
);

const ResourceIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0' />
    <path d='M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0' />
    <path d='M3 6v13' />
    <path d='M12 6v13' />
    <path d='M21 6v13' />
  </svg>
);

const LocationIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M12 11m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
    <path d='M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z' />
  </svg>
);

const CheckInIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v8' />
    <path d='M15 19l2 2l4 -4' />
  </svg>
);

const ImpactIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
    <path d='M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
    <path d='M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
    <path d='M4 20h14' />
  </svg>
);

const ReportIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2' />
    <path d='M8 5a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z' />
    <path d='M10 14l4 -4' />
  </svg>
);

export type MessageTypeAction =
  | 'poll'
  | 'activity_link'
  | 'roster_link'
  | 'resource_link'
  | 'location_share'
  | 'cico_link'
  | 'impact_share'
  | 'report_share';

interface MessageTypeMenuProps {
  isAdmin: boolean;
  menuActionClass: string;
  onSelect: (type: MessageTypeAction) => void;
  children: React.ReactElement;
}

const adminItems: Array<{ type: MessageTypeAction; label: string; Icon: React.FC }> = [
  { type: 'poll', label: 'Create Poll', Icon: PollIcon },
  { type: 'activity_link', label: 'Share Activity', Icon: ActivityIcon },
  { type: 'roster_link', label: 'Share Roster', Icon: RosterIcon },
  { type: 'resource_link', label: 'Share Resource', Icon: ResourceIcon },
  { type: 'location_share', label: 'Share Location', Icon: LocationIcon },
  { type: 'cico_link', label: 'Share Check In', Icon: CheckInIcon },
  { type: 'impact_share', label: 'Share Impact', Icon: ImpactIcon },
  { type: 'report_share', label: 'Share Report', Icon: ReportIcon },
];

export const MessageTypeMenu = ({ isAdmin, menuActionClass, onSelect, children }: MessageTypeMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (type: MessageTypeAction) => {
    setOpen(false);
    onSelect(type);
  };

  return (
    <TooltipMenu
      open={open}
      onClose={() => setOpen(false)}
      title={
        <Box
          display='flex'
          flexDirection='column'
          alignItems='flex-start'
          style={{ padding: '4px 8px', minWidth: 180 }}
        >
          {isAdmin &&
            adminItems.map(({ type, label, Icon }) => (
              <Button key={type} className={menuActionClass} startIcon={<Icon />} onClick={() => handleSelect(type)}>
                <Typography>{label}</Typography>
              </Button>
            ))}
          {!isAdmin && (
            <Box p={1}>
              <Typography style={{ color: '#999', fontSize: '13px' }}>No actions available</Typography>
            </Box>
          )}
        </Box>
      }
    >
      <span onClick={() => setOpen(true)}>{children}</span>
    </TooltipMenu>
  );
};
